<template>
  <div class="dh-ad-rotator" :class="{'d-none': !visible}" v-if="currentAdContent && !prerender">
    <div v-html="currentAdContent"></div>
  </div>
</template>

<script>
import {ref, onMounted, onUnmounted} from 'vue';



export default {
  props: {
    selector: {
      type: String,
      default: '.advertise'
    },
    showImmediately: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  name: 'AdRotator',
  setup(props) {
    const currentAdContent = ref('');
    const currentAdIndex = ref(-1);
    const ads = ref([]);
    const prerender = ref(window.__PRERENDER_INJECTED)

    const findAds = () => {
      // Find all ad elements in the document
      const adElements = document.querySelectorAll(props.selector);
      ads.value = Array.from(adElements);

    };

    const displayAd = (index) => {
      // Hide all ads in original location
      ads.value.forEach(ad => {
        ad.classList.add('d-none');
      });

      // Get and display the selected ad
      const selectedAd = ads.value[index];
      currentAdContent.value = selectedAd?.innerHTML ?? "";
      currentAdIndex.value = index;
    };

    onUnmounted(() =>{
    });

    onMounted(() => {
      findAds();
      if(props.showImmediately){
        rotateAd();
      }
      currentAdContent.value = currentAdIndex.value >= 0 ? currentAdIndex.value : 0;
      displayAd(currentAdIndex.value);
    });

    function rotateAd(){
      const adElements = document.querySelectorAll(props.selector);
      currentAdIndex.value = (currentAdIndex.value + 1) % adElements.length;
      displayAd(currentAdIndex.value);
    }

    return {
      rotateAd,
      currentAdContent,
      prerender
    };
  }
}
</script>
